import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { library } from "@fortawesome/fontawesome-svg-core";
import moment from "moment-jalaali";
import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken as getFirebaseToken,
  onMessage,
} from "firebase/messaging";
import "./removeLegacyServiceWorker";
import {
  faHome,
  faBook,
  faEnvelope,
  faAddressCard,
  faComment,
  faUserPlus,
  faCreditCard,
  faHistory,
  faTasks,
  faFile,
  faChartArea,
  faIdCard,
  faPlane,
  faSave,
  faCar,
  faTrain,
  faLink,
  faTimes,
  faCalculator,
  faUniversity,
  faFileExcel,
  faQuestionCircle,
  faAngleLeft,
  faAngleDown,
  faUsers,
  faUserCircle,
  faCheckDouble,
  faSearch,
  faCalendarAlt,
  faClock,
  faCheck,
  faBriefcase,
  faExclamation,
  faHashtag,
  faGlobe,
  faAngleRight,
  faAngleDoubleRight,
  faMoneyBill,
  faUser,
  faDownload,
  faSignal,
  faCertificate,
  faHeart,
  faChalkboardTeacher,
  faFileSignature,
  faUserClock,
  faTimesCircle,
  faExchangeAlt,
  faChalkboard,
  faFileAlt,
  faHandPaper,
  faBuilding,
  faArrowsAltH,
  faMicrophone,
  faPoll,
  faCalendarTimes,
  faComments,
  faQuran,
  faPhone,
  faUserCog,
  faBookOpen,
  faFileWord,
  faCode,
  faLightbulb,
  faTrophy,
  faMosque,
  faNewspaper,
  faMapMarkedAlt,
  faCity,
  faChevronLeft,
  faChevronRight,
  faChair,
  faUtensils,
  faFlag,
  faEdit,
  faInfo,
  faList,
  faChevronUp,
  faChevronDown,
  faCircle,
  faMinus,
  faSchool,
  faBiking,
  faFutbol,
  faTableTennis,
  faSwimmer,
  faChild
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faHome,
  faBook,
  faEnvelope,
  faAddressCard,
  faComment,
  faUserPlus,
  faCreditCard,
  faHistory,
  faTasks,
  faFile,
  faChartArea,
  faIdCard,
  faPlane,
  faSave,
  faCar,
  faTrain,
  faLink,
  faTimes,
  faCalculator,
  faFileExcel,
  faUniversity,
  faQuestionCircle,
  faAngleLeft,
  faAngleDown,
  faUsers,
  faUserCircle,
  faCheckDouble,
  faSearch,
  faCalendarAlt,
  faClock,
  faCheck,
  faBriefcase,
  faExclamation,
  faHashtag,
  faGlobe,
  faAngleRight,
  faAngleDoubleRight,
  faBuilding,
  faMoneyBill,
  faUser,
  faDownload,
  faSignal,
  faCalendarCheck,
  faCertificate,
  faHeart,
  faChalkboardTeacher,
  faFileSignature,
  faUserClock,
  faTimesCircle,
  faExchangeAlt,
  faChalkboard,
  faMoneyBill,
  faFileAlt,
  faHandPaper,
  faArrowsAltH,
  faMicrophone,
  faClock,
  faChartBar,
  faPoll,
  faCalendarTimes,
  faComments,
  faQuran,
  faPhone,
  faUserCog,
  faBookOpen,
  faFileWord,
  faCode,
  faLightbulb,
  faTrophy,
  faMosque,
  faNewspaper,
  faMapMarkedAlt,
  faCity,
  faChevronLeft,
  faChevronRight,
  faChair,
  faUtensils,
  faFlag,
  faEdit,
  faInfo,
  faList,
  faChevronUp,
  faChevronDown,
  faCircle,
  faMinus,
  faSchool,
  faTableTennis,
  faFutbol,
  faBiking,
  faSwimmer,
  faChild
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
  faCalendarCheck,
  faChartBar,
} from "@fortawesome/free-regular-svg-icons";
Vue.component("date-picker", VuePersianDatetimePicker);
Vue.config.productionTip = false;

window.popStateDetected = false;
window.addEventListener("popstate", () => {
  window.popStateDetected = true;
});
Vue.mixin({
  methods: {
    toJalaliDateTime: (dateTime) =>
      moment(dateTime, "D-M-YYYY HH:mm:ss").format("jYYYY/jM/jD HH:mm:ss"),
    toJalaliTimestamp: (timestamp) => moment(timestamp).format("jYYYY/jM/jD"),
    numberWithCommas: (x) => x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
  },
});

var firebaseConfig = {
  apiKey: "AIzaSyBMTYNZTb8csE8YSKTfB6SXShmfgVoFB8w",

  authDomain: "hozehkh-376ba.firebaseapp.com",

  projectId: "hozehkh-376ba",

  storageBucket: "hozehkh-376ba.appspot.com",

  messagingSenderId: "555244843579",

  appId: "1:555244843579:web:8a1d0a0772f9caa87e621e",
};

initializeApp(firebaseConfig);
navigator.serviceWorker
  .register("./firebase-messaging-sw.js", {
    scope: "firebase-cloud-messaging-push-scope",
  })
  .then(async (registration) => {
    const messaging = getMessaging();
    //messaging.useServiceWorker(registration);
    onMessageListener(messaging)
      .then((payload) => {
        console.log("message received");
        store.commit(
          "SET_UNREAD_MESSAGE_COUNT",
          store.getters.UnreadMessagesCount + 1
        );
        store.commit(
          "SET_SNACKBAR_TEXT",
          "شما یک پیام جدید دارید: " + payload.notification.title
        );
      })
      .catch((err) => console.log("failed: ", err));
  })
  .catch((err) => {
    console.log(err);
  });
export const onMessageListener = (messaging) =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
new Vue({
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
